import styles from './UIGamePlayerInformationCards.module.scss'
import {PlayerColor} from '@colonist/game-states'
import {T} from '../../../common/T'
import {Tooltip} from '../../../common/Tooltip'
import {UIGameCount} from '../../../common/UIGameCount/UIGameCount'
import clsx from 'clsx'
import React, {ReactNode} from 'react'
import {CardValidatorOrdered} from '@colonist/game-mechanic-validators'
import {UIGameProgressCardTooltipBody} from '../../../common/UIGameProgressCardTooltipBody/UIGameProgressCardTooltipBody'
import CardResCardBack from '@static/images/card_rescardback.svg'
import CardProgressBack from '@static/images/card_progress_back.svg'
import CardDevCardBack from '@static/images/card_devcardback.svg'
import CardResCardOverLimit from '@static/images/card_rescardoverlimit.svg'
import {ImageURL} from '@colonist/types'

const CustomCard = ({
    count,
    tooltipBody,
    tooltipTitle,
    cardImage, centerText,
}: {
    count?: number
    tooltipBody: ReactNode
    tooltipTitle?: ReactNode
    cardImage: ImageURL
    centerText?: boolean
}) => <Tooltip
    centerText={centerText}
    className={styles.cardContainer}
    content={tooltipBody}
    title={tooltipTitle}>
    <img
        className={styles.cardImage}
        src={cardImage}
    />
    {count != null && (
        <UIGameCount
            className={styles.countBadge}
            color={PlayerColor.Blue}
            count={count}
        />
    )}
</Tooltip>

export interface UIGamePlayerInformationCardsProps {
    isCityAndKnightMode: boolean
    isCurrentUser: boolean
    amountOfDevelopmentCards: number
    translationContext: any
    amountOfResourceCards: number
    cardDiscardLimit: number
    progressCards: CardValidatorOrdered
}

export const UIGamePlayerInformationCards = ({
    isCityAndKnightMode,
    isCurrentUser,
    amountOfDevelopmentCards,
    translationContext,
    amountOfResourceCards,
    cardDiscardLimit,
    progressCards,
}: UIGamePlayerInformationCardsProps) => {
    const isResourceCardOverLimit = amountOfResourceCards > cardDiscardLimit

    return (
        <div className={clsx(styles.container, {
            [styles.currentUser]: isCurrentUser,
        })}>
            <div data-resource-card>
                <CustomCard
                    cardImage={isResourceCardOverLimit ? CardResCardOverLimit : CardResCardBack}
                    count={amountOfResourceCards}
                    tooltipBody={
                        <>
                            <div><T id={{
                                key: 'strings:game.playerInformation.resourceCard.body',
                                options: {context: translationContext},
                            }}/></div>
                            {isResourceCardOverLimit && <div><br/><T id={{
                                key: 'strings:game.playerInformation.resourceCard.discardLimitTip',
                                options: {count: cardDiscardLimit},
                            }}/></div>}
                        </>
                    }
                    tooltipTitle={<T id={{
                        key: 'strings:game.playerInformation.resourceCard.title',
                        options: {context: translationContext},
                    }}/>}
                />
            </div>
            <div data-development-card>
                {isCityAndKnightMode ? <CustomCard
                    cardImage={CardProgressBack}
                    centerText
                    count={amountOfDevelopmentCards}
                    tooltipBody={<UIGameProgressCardTooltipBody
                        progressCards={progressCards}
                    />}
                    tooltipTitle={<T id='strings:game.playerInformation.progressCard'/>}
                /> : <CustomCard
                    cardImage={CardDevCardBack}
                    count={amountOfDevelopmentCards}
                    tooltipBody={<T id='strings:game.playerInformation.developmentCard.body'/>}
                    tooltipTitle={<T id='strings:game.playerInformation.developmentCard.title'/>}
                />}
            </div>
        </div>
    )
}
